<script lang="ts">
	//Helpers
	import * as schedules from '../SchedulesHelpers/schedules';
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format, _ } from 'svelte-i18n';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
	//Configs
	import { devices_config } from '@devices/index';
	import { devicesConfigSchedules } from './schedules_config';
	//Components
	import SchedulesListV2 from '../SchedulesHelpers/SchedulesListV2.svelte';
	import CreateScheduleG1 from '../SchedulesG1/CreateScheduleG1.svelte';
	//Design system components
	import { Button, toast, Toggle, Alert } from '@Shelly/shelly-design-system';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device,
		mode = '';

	const dispatcher = createEventDispatcher();

	const id = real_id(device.id);

	$: statusStore = getDeviceStatus(id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let props,
		local_ip = get_local_ip(id),
		loading = false;

	let data = {
		...devicesConfigSchedules[device.type].schedules,
	};

	let showModal = false;
	if (typeof $statusStore !== 'undefined') {
		status = $statusStore;
		mode =
			typeof status.mode !== 'undefined'
				? status.mode
				: $settingsStore.mode && $settingsStore.mode !== '_unknown_'
					? $settingsStore.mode
					: devices_config[$devices[id].type].family
						? devices_config[$devices[id].type].family
						: '';
		// device_settings = Object.values(  );
	}

	let category = device.category === 'emeter' ? 'relay' : device.category;

	$: settingsChannel =
		settings[category + 's'] && category !== 'sensor'
			? settings[category + 's'][device.category === 'emeter' ? 0 : device.channel]
			: settings;

	let tempRange: any = devices_config[$devices[id].type].modes[mode].color_temp
		? [
				devices_config[$devices[id].type].modes[mode].color_temp.minValue,
				devices_config[$devices[id].type].modes[mode].color_temp.maxValue,
			]
		: '';

	$: checked = settingsChannel?.schedule;

	$: schedule_rules = settingsChannel?.schedule_rules;

	const scheduleCreation = (index?, rule?, edit?) => {
		//this will trigger modal with schedule componnents, props and callback function
		rule = { ...data, ...rule, tempRange };
		props = {
			...rule,
			index,
			device,
			callback: handleSave,
			tempRange,
			edit: edit,
		};
		showModal = true;
	};

	async function handleDelete(e) {
		let index = e.detail;
		let res;
		loading = true;
		settingsChannel.schedule_rules = await schedules.scheduleDelete(
			settingsChannel.schedule_rules,
			index,
		);

		if (local_ip) {
			res = await localReq(device, `${local_ip}/settings/${category}/${device.channel}`, 'post', {
				enabled: settingsChannel.schedule ? 1 : 0,
				schedule_rules: settingsChannel.schedule_rules.join(','),
			});
		} else {
			res = await postReq(
				`/device/${category === 'roller' ? 'relay/roller' : category}/settings/schedule_rules`,
				{
					id: id,
					channel: device.category === 'emeter' ? 0 : device.channel,
					enabled: settingsChannel.schedule ? 1 : 0,
					schedule_rules: settingsChannel.schedule_rules.join(','),
				},
			);
		}
		if (res.isok) {
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('sched_del_scc_toast') || 'Schedule rule deleted.',
			});
		} else {
			toast.open({ type: 'warning', title: $format('error_global') });
		}
		loading = false;
	}

	async function handleEdit(e) {
		//this functoin will attach data to modal and then rule can be edited

		let index = e.detail.index;
		let rule = await e.detail.rule;
		let edit = true;

		rule = { ...data, ...rule };
		schedules.editSchedule(settingsChannel.schedule_rules);
		scheduleCreation(index, rule, edit);
	}

	async function toggleSchedule() {
		let res;
		loading = true;
		settingsChannel.schedule = !settingsChannel.schedule;
		settings = { ...settings, ...settingsChannel };
		if (local_ip) {
			res = await localReq(device, `${local_ip}/settings/${category}/${device.channel}`, 'post', {
				schedule: settingsChannel.schedule ? 1 : 0,
			});
		} else {
			res = await postReq(
				`/device/${category === 'roller' ? 'relay/roller' : category}/settings/schedule_rules`,
				{
					id: id,
					channel: device.category === 'emeter' ? 0 : device.channel,
					enabled: settingsChannel.schedule ? 1 : 0,
					schedule_rules: settingsChannel.schedule_rules.join(','),
				},
			);
		}
		if (res.isok) {
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title:
					$format(`schedules_${settingsChannel.schedule ? 'enabled' : 'disabled'}`) ||
					`Schedule rules are ${settingsChannel.schedule ? 'enabled' : 'disabled'}.`,
			});
		} else {
			toast.open({ type: 'warning', title: $format('error_global') });
		}
		loading = false;
	}

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: scheduleCreation,
				loading,
				disabled: loading,
				label: $format('button_add_schedule', { default: 'Add schedule' }),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});

	async function handleSave(props) {
		loading = true;
		let schedule_rule = await schedules.scheduleDataFormatSent(props, device); //data assembling before request

		let res;
		let cache = settingsChannel.schedule_rules;

		if (schedule_rule[schedule_rule.length - 1] === '-') {
			return toast.open({
				type: 'info',
				title: $format('schedules_wrong_selection_err_toast', {
					default: 'Wrong selection was made. Please try again!',
				}),
			});
		}

		if (!schedule_rule) {
			return toast.open({
				type: 'info',
				title: $format('schedule_creation_info') || 'Please select at least one day',
			});
		}
		if (!props.edit) {
			settingsChannel.schedule_rules.push(schedule_rule);
		}

		settings = { ...settings, ...settingsChannel };

		if (schedule_rule !== null) {
			let rules;
			if (
				settingsChannel.schedule_rules.length === undefined ||
				settingsChannel.schedule_rules.length === 0
			) {
				rules = schedule_rule;
			} else {
				rules = schedules.editSchedule(
					settingsChannel.schedule_rules,
					schedule_rule,
					props.index,
				);
			}
			rules = schedules.unify_schedules(rules);
			if (local_ip) {
				res = await localReq(
					device,
					`${local_ip}/settings/${category}/${device.channel}`,
					'post',
					{
						enabled: settingsChannel.schedule ? 1 : 0,
						schedule_rules: rules,
					},
				);
			} else {
				res = await postReq(
					`/device/${category === 'roller' ? 'relay/roller' : category}/settings/schedule_rules`,
					{
						id: id,
						channel: device.category === 'emeter' ? 0 : device.channel,
						enabled: settingsChannel.schedule ? 1 : 0,
						schedule_rules: rules,
					},
				);
			}
			if (res.isok) {
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title: $format('sched_save_scc_toast') || 'Schedule rule saved.',
				});
				dispatcher('close');
			} else {
				settingsChannel.schedule_rules = cache;
				settings = { ...settings, ...settingsChannel };
				toast.open({ type: 'warning', title: 'Something went wrong!' });
			}
			loading = false;
		}
	}
</script>

{#if showModal}
	<CreateScheduleG1 {props} on:close={() => (showModal = false)} bind:showModal />
{/if}
<Toggle
	size="l"
	class="mb-s"
	disabled={settingsChannel.schedule_rules.length === 0}
	{checked}
	on:click={toggleSchedule}
	id="toggle-5tje30j"
>
	{$format('label_enable_all_weakly_schedules', {
		default: 'Enable all weekly schedules',
	})}
</Toggle>
<hr class="mb-m" />

{#if typeof settingsChannel !== 'undefined' && typeof settingsChannel.schedule_rules !== 'undefined' && settingsChannel.schedule_rules.length}
	<SchedulesListV2
		{device}
		schedule_rules={schedules.scheduleDataFormatReceive(schedule_rules, tempRange, device, checked)}
		{tempRange}
		{checked}
		on:edit={handleEdit}
		on:delete={handleDelete}
	/>
{:else}
	<Alert
		heading={$format('alert_heading_no_schedules')}
		message={$format('first_add_schedule', {
			default: 'If you want to use this feature, you first need to add a schedule.',
		})}
		isHeadingBold
	/>
{/if}

{#if !$showNewLayout}
	<div class="pt-s">
		<Button
			class="width-full"
			{loading}
			disabled={loading}
			size="m"
			variant={'primary'}
			on:click={scheduleCreation}
		>
			{$format('button_add_schedule', {
				default: 'Add schedule',
			})}
		</Button>
	</div>
{/if}
